import React from "react";

function inline(text, keyBase) {
  // Render **bold** segments.
  const parts = text.split(/(\*\*[^*]+\*\*)/g).filter(Boolean);
  return parts.map((p, i) => {
    if (p.startsWith("**") && p.endsWith("**")) {
      return (
        <strong key={`${keyBase}-${i}`} className="font-bold text-[#36302B]">
          {p.slice(2, -2)}
        </strong>
      );
    }
    return <React.Fragment key={`${keyBase}-${i}`}>{p}</React.Fragment>;
  });
}

export function RichText({ content }) {
  const lines = (content || "").split("\n");
  const blocks = [];
  let list = [];

  const flushList = (idx) => {
    if (list.length) {
      blocks.push(
        <ul key={`ul-${idx}`} className="my-3 space-y-2 pl-1">
          {list.map((li, i) => (
            <li key={i} className="flex gap-3 text-[15px] leading-relaxed text-[#36302B]/90">
              <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#C57B67]" />
              <span>{inline(li, `li-${idx}-${i}`)}</span>
            </li>
          ))}
        </ul>
      );
      list = [];
    }
  };

  lines.forEach((raw, i) => {
    const line = raw.trim();
    if (!line) {
      flushList(i);
      return;
    }
    if (line.startsWith("• ")) {
      list.push(line.slice(2));
      return;
    }
    flushList(i);
    if (line.startsWith("## ")) {
      blocks.push(
        <h3 key={i} className="font-display mt-6 mb-2 text-xl font-medium text-[#36302B]">
          {line.slice(3)}
        </h3>
      );
    } else if (line.startsWith("> ")) {
      blocks.push(
        <blockquote
          key={i}
          className="my-4 rounded-2xl border-l-4 border-[#D8A7A7] bg-[#D8A7A7]/10 px-5 py-4 font-display text-[15px] italic leading-relaxed text-[#36302B]/85"
        >
          {inline(line.slice(2), `q-${i}`)}
        </blockquote>
      );
    } else {
      blocks.push(
        <p key={i} className="my-3 text-[15px] leading-[1.75] text-[#36302B]/90">
          {inline(line, `p-${i}`)}
        </p>
      );
    }
  });
  flushList("end");

  return <div>{blocks}</div>;
}
